import { render, staticRenderFns } from "./valuationStock.vue?vue&type=template&id=a70b1198&scoped=true&"
import script from "./valuationStock.vue?vue&type=script&lang=js&"
export * from "./valuationStock.vue?vue&type=script&lang=js&"
import style0 from "./valuationStock.vue?vue&type=style&index=0&id=a70b1198&lang=scss&scoped=true&"
import style1 from "./valuationStock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70b1198",
  null
  
)

export default component.exports